App.addModule(function(app) {

    app.on('loaded', () => {
        
	    if (BS.isScreenXs()) {
		    return;
	    }
	    
	    var button = $('.scroll-to-top');
	    
	    $(window).on('scroll', function () {
		    
		    var pos = $(this).scrollTop();
		    
            if (pos > 600) {
            	button.fadeIn();
            } else {
            	button.fadeOut();
            }
        });
    })
})
